"use client";

// packages/eden-resize-observer/src/index.js
import { useEffect } from "react";
var MockResizeObserver = class {
  observe() {
  }
  unobserve() {
  }
  disconnect() {
  }
};
var memoizedResizeObserverProxy;
function getMemoizedResizeObserverProxy() {
  if (!memoizedResizeObserverProxy) {
    memoizedResizeObserverProxy = createResizeObserverProxy();
  }
  return memoizedResizeObserverProxy;
}
function createResizeObserverProxy() {
  const callbacksMap = /* @__PURE__ */ new Map();
  function callback(entries) {
    callbacksMap.forEach((targetSet, callback2) => {
      const entriesForThisCallback = entries.filter(
        (entry) => targetSet.has(entry.target)
      );
      if (entriesForThisCallback.length > 0) {
        callback2(entriesForThisCallback);
      }
    });
  }
  try {
    let resizeObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(callback);
    } else {
      resizeObserver = new MockResizeObserver(callback);
    }
    return {
      resizeObserver,
      add(callback2, target, options) {
        if (target) {
          resizeObserver.observe(target, options);
          if (!callbacksMap.has(callback2)) {
            callbacksMap.set(callback2, /* @__PURE__ */ new Set());
          }
          const targetSet = callbacksMap.get(callback2);
          targetSet.add(target);
        }
      },
      remove(callback2, target) {
        if (target) {
          const targetSet = callbacksMap.get(callback2) ?? /* @__PURE__ */ new Set();
          targetSet.delete(target);
          if (targetSet.size === 0) {
            callbacksMap.delete(callback2);
          }
          if (!Array.from(callbacksMap.values()).some(
            (targetSet2) => targetSet2.has(target)
          )) {
            resizeObserver.unobserve(target);
          }
        }
      }
    };
  } catch (error) {
    console.warn(
      "eden-resize-observer could not create a ResizeObserver:",
      error
    );
  }
}
function useResizeObserver(callback, refOrElement, options) {
  const proxy = getMemoizedResizeObserverProxy();
  useEffect(() => {
    if (!callback || !refOrElement) {
      console.error(
        "eden-resize-observer:",
        new TypeError("The `callback` and `target` arguments are required.")
      );
      return;
    }
    if (proxy) {
      const target = refOrElement && "current" in refOrElement ? refOrElement.current : refOrElement;
      proxy.add(callback, target, options);
      return () => proxy.remove(callback, target);
    }
  }, [callback, options, proxy, refOrElement]);
}
export {
  useResizeObserver
};
